// removed by extract-text-webpack-plugin
module.exports = {"container":"container_32S0Q","svg":"svg_iNQmV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/gameboard/control_header/style.scss
// module id = 149
// module chunks = 0